module.exports = __webpack_public_path__ + "img/app-image1.debc52c5.png";